angular.module('app').service('ZoneShapeDrawing', function() {
    function ZoneShapeDrawing(map, callbacks, $scope) {
        this.shapes = ['RECTANGLE', 'CIRCLE', 'POLYGON', 'POLYLINE'];

        this.map = map;
        this.scope = $scope;
        this.dm = null;

        this.state = 'reset';
        this.overlay = null;

        this.shape = this.shapes[0];
        this.parameters = {};

        this.initDrawingManager();

        if (callbacks) {
            this.callbacks = callbacks;
        }
    }

    ZoneShapeDrawing.prototype.changeShape = function(shape) {
        this.shape = shape;
        this.dm.setOptions({ drawingMode: google.maps.drawing.OverlayType[shape] });
    };

    ZoneShapeDrawing.prototype.setSelectedShape = function(shape) {
        this.setDrawingState('reset');
        this.changeShape(shape);

        var parameters = this.getDefaultShapeParameters(shape);
        if (parameters) {
            this.loadShape(shape, parameters);
        } else {
            this.setIsDrawingManagerEditable(true);
            this.setDrawingState('draw');
        }
    };

    ZoneShapeDrawing.prototype.getSelectedShape = function() {
        return this.shape;
    };

    ZoneShapeDrawing.prototype.initDrawingManager = function() {
        this.dm = new google.maps.drawing.DrawingManager({
            drawingMode: null,
            drawingControl: false,
            drawingControlOptions: {
                drawingModes: ['circle', 'polygon', 'polyline', 'rectangle'],
            },
        });

        this.setIsDrawingManagerEditable(true);
        var _self = this;

        google.maps.event.addListener(this.dm, 'overlaycomplete', function(event) {
            if (event.type !== google.maps.drawing.OverlayType.MARKER) {
                _self.setDrawingState('edit');
                _self.overlay = event.overlay;

                _self.scope.$apply();
            }
        });

        this.dm.setMap(this.map);
    };

    ZoneShapeDrawing.prototype.getDrawingManager = function() {
        return this.dm;
    };

    ZoneShapeDrawing.prototype.setIsDrawingManagerEditable = function(editable) {
        var _self = this;
        ['circle', 'polygon', 'polyline', 'rectangle'].map(function(value) {
            var options = {};
            options[value + 'Options'] = {
                clickable: editable,
                editable: editable,
            };

            _self.dm.setOptions(options);
        });
    };

    ZoneShapeDrawing.prototype.getDrawingState = function() {
        return this.state;
    };

    ZoneShapeDrawing.prototype.getDefaultShapeParameters = function(shape) {
        var center = this.map.center;
        var parameters = {};

        switch (shape) {
            case 'CIRCLE':
                parameters = {
                    center: {
                        lat: center.lat(),
                        lng: center.lng(),
                    },
                    radius: 2,
                };
                break;
            case 'RECTANGLE':
                parameters = {
                    bottomLeft: {
                        lat: center.lat() - 0.005,
                        lng: center.lng() - 0.01,
                    },
                    topRight: {
                        lat: center.lat() + 0.005,
                        lng: center.lng() + 0.01,
                    },
                };
                break;
            case 'POLYLINE':
            case 'POLYGON':
                return false;
        }
        return parameters;
    };

    ZoneShapeDrawing.prototype.drawInitialShape = function() {
        this.setSelectedShape('CIRCLE');
        this.setDrawingState('edit');
    };

    ZoneShapeDrawing.prototype.setDrawingState = function(state) {
        switch (state) {
            case 'draw':
                this.dm.setOptions({ drawingMode: google.maps.drawing.OverlayType[this.shape] });

                break;
            case 'edit':
                this.setIsDrawingManagerEditable(true);
                this.dm.setDrawingMode(null);

                break;
            case 'show':
                this.setIsDrawingManagerEditable(false);
                this.dm.setDrawingMode(null);

                break;
            case 'reset':
                this.dm.setOptions({ drawingMode: null });
                if (this.overlay) {
                    this.overlay.setMap(null);
                    google.maps.event.clearInstanceListeners(this.overlay);
                    this.overlay = null;
                }

                break;
        }
        this.state = state;

        if (typeof this.callbacks.onChangeDrawingState === 'function') {
            this.callbacks.onChangeDrawingState(state);
        }
    };

    ZoneShapeDrawing.prototype.getShapeOverlay = function(shape, parameters, editable, color) {
        var data;
        var bounds = new google.maps.LatLngBounds();

        switch (shape) {
            case 'CIRCLE':
                data = {
                    center: {
                        lat: decimal(parameters.center.lat),
                        lng: decimal(parameters.center.lng),
                    },
                    radius: decimal(parameters.radius) * 1000,
                };
                break;
            case 'RECTANGLE':
                data = {
                    bounds: {
                        north: decimal(parameters.topRight.lat),
                        south: decimal(parameters.bottomLeft.lat),
                        east: decimal(parameters.topRight.lng),
                        west: decimal(parameters.bottomLeft.lng),
                    },
                };
                break;
            case 'POLYLINE':
            case 'POLYGON':
                data = {
                    path: parameters.points,
                };
                break;
        }

        var options = data;
        if (editable) {
            options = angular.extend(data, {
                editable: true,
                clickable: true,
            });
        }

        if (color) {
            options = angular.extend(data, {
                fillColor: color,
                strokeColor: color,
            });
        }

        var type = shape.toLowerCase();
        type = type.charAt(0).toUpperCase() + type.slice(1);

        var overlay = new google.maps[type](options);

        if (['CIRCLE', 'RECTANGLE'].indexOf(shape) !== -1) {
            bounds.union(overlay.getBounds());
        } else {
            var points = overlay.getPath().getArray();
            for (var n = 0; n < points.length; n++) {
                bounds.extend(points[n]);
            }
        }

        return {
            overlay: overlay,
            bounds: bounds,
        };
    };

    ZoneShapeDrawing.prototype.change = function() {
        var data = this.getShapeOverlay(this.shape, this.parameters, true);

        if (this.overlay) {
            this.overlay.setMap(null);
            google.maps.event.clearInstanceListeners(this.overlay);
            this.overlay = null;
        }

        this.overlay = data.overlay;
        this.overlay.setMap(this.map);

        this.setGoogleShapeChangeEvents(this.shape, this.overlay);
    };

    function decimal(num) {
        return Math.round(num * 1000000) / 1000000;
    }

    ZoneShapeDrawing.prototype.setGoogleShapeChangeEvents = function(shape, overlay) {
        var _self = this;

        function setParameters(shape, overlay) {
            var parameters = false;

            switch (shape) {
                case 'CIRCLE':
                    parameters = {
                        center: {
                            lat: decimal(overlay.center.lat()),
                            lng: decimal(overlay.center.lng()),
                        },
                        radius: decimal(overlay.radius) / 1000,
                    };
                    break;
                case 'RECTANGLE': {
                    var bounds = overlay.getBounds();
                    var NE = bounds.getNorthEast();
                    var SW = bounds.getSouthWest();

                    parameters = {
                        topRight: {
                            lat: decimal(NE.lat()),
                            lng: decimal(NE.lng()),
                        },
                        bottomLeft: {
                            lat: decimal(SW.lat()),
                            lng: decimal(SW.lng()),
                        },
                    };
                    break;
                }
            }
            _self.parameters = parameters;

            return parameters;
        }

        switch (shape) {
            case 'CIRCLE':
                setParameters(shape, overlay);

                google.maps.event.addListener(overlay, 'radius_changed', function() {
                    setParameters(shape, overlay);
                    _self.scope.$apply();
                });
                google.maps.event.addListener(overlay, 'center_changed', function() {
                    setParameters(shape, overlay);
                    _self.scope.$apply();
                });

                break;
            case 'RECTANGLE':
                setParameters(shape, overlay);

                google.maps.event.addListener(overlay, 'bounds_changed', function() {
                    setParameters(shape, overlay);
                    _self.scope.$apply();
                });

                break;
        }

        return true;
    }

    ZoneShapeDrawing.prototype.loadShape = function(shape, parameters) {
        this.setDrawingState('reset');
        this.changeShape(shape);

        this.setIsDrawingManagerEditable(true);
        this.setDrawingState('edit');

        var data = this.getShapeOverlay(shape, parameters, true);

        this.overlay = data.overlay;
        this.overlay.setMap(this.map);

        this.setGoogleShapeChangeEvents(this.shape, this.overlay);

        return data;
    };

    return ZoneShapeDrawing;
});
